var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 63,
    viewBox: "0 0 72 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6682 0C23.3131 0 21.1887 1.43168 20.2812 3.63037L17.9198 9.35156H9.72973C4.35615 9.35156 0 13.7588 0 19.1953V53.1562C0 58.5928 4.35615 63 9.72973 63H62.2703C67.6439 63 72 58.5928 72 53.1562V19.1953C72 13.7588 67.6439 9.35156 62.2703 9.35156H54.0802L51.7188 3.63036C50.8113 1.43168 48.6869 0 46.3318 0H25.6682ZM53.5135 36.1758C53.5135 45.8257 45.6724 53.6484 36 53.6484C26.3276 53.6484 18.4865 45.8257 18.4865 36.1758C18.4865 26.5259 26.3276 18.7031 36 18.7031C45.6724 18.7031 53.5135 26.5259 53.5135 36.1758ZM36 47.25C42.0185 47.25 46.8973 42.3139 46.8973 36.225C46.8973 30.1361 42.0185 25.2 36 25.2C29.9816 25.2 25.1028 30.1361 25.1028 36.225C25.1028 42.3139 29.9816 47.25 36 47.25Z",
    fill: "#36434E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/camera-icon.dada85cdac4a3ef1e452f20c616e9216.svg";
export { ForwardRef as ReactComponent };